import React from 'react';
import Sidebar from '../../Sidebar/Sidebar';

const Payment = () => {
    return (
        <div>
            <div className='row'>
          <div className=' col-lg-2 col-md-4 col-12 left-site'>
            <Sidebar></Sidebar>    
            </div>

          <div className='col-lg-10 col-md-8 col-12'>
          <div>
            <img src="https://images2.imgbox.com/68/8d/P0Fsg5gZ_o.png" className ='img-fluid w-75 mx-auto' alt="" />
          </div>
          </div>
        </div>
        </div>
    );
};

export default Payment;